<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Checklists'"
      [showLoadingSpinner]="showLoadingSpinner"
      [showDropdownMenu]="hasAddresses && hasToDoLists && listLoaded && !editPrio"
      [dropdownMenu]="mobileDropdownMenu"
      [customBack]="editPrio ? null : backPage"
      [canGoBack]="!windowService.isDesktopRes"
      [customBackAction]="handleBackButton.bind(this)"
      />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [hasBottomNav]="false" [isPrimaryLayer]="false" (contentHeight)="contentHeight = $event" (click)="onWrapperClick($event)">


    @if (loaded) {
      @if (!hasAddresses && !showAboutThisPage) {
        <tidy-row [align]="'center'">
          <tidy-text [body]="'Please add a property to view checklists.'" />
        </tidy-row>
        <tidy-button
          [text]="'Add Property'"
          [action]="goToDashboard.bind(this)"
          class="primary full-width" />
      }
      @if (!windowService.isDesktopRes && !toDosOnboarding && !neverBookedJobs && hasToDoLists && !isRightSideContent && hasAddresses) {
        <tidy-two-column-row class="extra-bottom-padding">
          @if (addressFilter && addressFilter.length > 0) {
            <tidy-filter
              [label]="'Property'"
              [showLabels]="true"
              [initValue]="addressId"
              [items]="addressFilter"
              (optionChange)="changeAddress($event, true)" />
          } @else {
            <div style="display: flex; flex-direction: column;">
              <tidy-text [fieldLabel]="'Property'" class="filter-label" style="margin-bottom: 4px;" />
              <ion-skeleton-text animated style="width: 100%; height: 30px; border-radius: 8px;" />
            </div>
          }
          @if (toDoFilter && toDoFilter.length > 0) {
            <tidy-filter
              [label]="'Checklist'"
              [showLabels]="true"
              [initValue]="taskListId"
              [items]="toDoFilter"
              (optionChange)="changeList($event)" />
          } @else {
            <div style="display: flex; flex-direction: column;">
              <tidy-text [fieldLabel]="'Checklist'" class="filter-label" style="margin-bottom: 4px;" />
              <ion-skeleton-text animated style="width: 100%; height: 30px; border-radius: 8px;" />
            </div>
          }
        </tidy-two-column-row>
      }
      @if (addressLoaded && !toDosOnboarding && hasAddresses) {
        @if (neverBookedJobs) {
          <tidy-row [align]="'center'">
            <tidy-text
              [body]="'No jobs booked at this property. Please book a job to use To-Dos.'" />
          </tidy-row>
          <tidy-button
            [text]="'Book Job(s)'"
            [action]="bookJob.bind(this, 'add_job')"
            class="primary" />
        }
        @if (!neverBookedJobs) {
          @if (listLoaded) {
            @if (!hasToDoLists) {
              <tidy-button
                [text]="'Get Started'"
                [action]="showChecklistOnboarding.bind(this)"
                class="primary" />
            }
            @if (listLoaded && hasToDoLists) {
              @if (listSelected()) {
                @if (selectedList?.description && !editPrio) {
                  <tidy-row class="extra-top-padding">
                    <tidy-text [helper]="selectedList?.description" />
                  </tidy-row>
                }
                @if (!editPrio) {
                  @if (windowService.isDesktopRes) {
                    <tidy-row class="extra-top-padding vertical-align-center" style="position: relative;">
                      <tidy-row class="vertical-align-center">
                        <tidy-image [src]="'assets/svg/camera-outline.svg'" class="body-size" />
                        <tidy-text [body]="'Remote Inspection:'" />
                        @if (remoteInspectionEnabled) {
                          <tidy-text [body]="'Take'" style="margin-left: 8px;" />
                          <tidy-header-select
                            [items]="remoteInspectionTypeItems"
                            [(ngModel)]="remoteInspectionType"
                            (optionChange)="onRemoteInspectionChange()"
                            style="margin-left: 5px;" />
                          <tidy-header-select
                            [items]="remoteInspectionWhenItems"
                            [(ngModel)]="remoteInspectionWhen"
                            (optionChange)="onRemoteInspectionChange()"
                            style="margin-left: 5px;" />
                          <tidy-text [body]="'Job'" style="margin-left: 5px;" />
                        }
                      </tidy-row>
                      <tidy-row class="vertical-align-center" style="position: absolute; right: 0;">
                        @if (!remoteInspectionEnabled) {
                          <tidy-text [body]="'OFF'" style="margin-right: 8px; color: var(--tidy-text-muted);" />
                        }
                        <tidy-toggle
                          [toggled]="remoteInspectionEnabled"
                          (toggleChanged)="toggleRemoteInspection()" />
                      </tidy-row>
                    </tidy-row>
                  } @else {
                    <tidy-row [alignLastItemRight]="true" class="extra-top-padding vertical-align-center">
                      <tidy-row class="vertical-align-center">
                        <tidy-image [src]="'assets/svg/camera-outline.svg'" class="body-size" />
                        <tidy-text [body]="'Remote Inspection:'" />
                      </tidy-row>
                      <tidy-row class="vertical-align-center" style="justify-content: flex-end;">
                        @if (!remoteInspectionEnabled) {
                          <tidy-text [body]="'OFF'" style="margin-right: 8px; color: var(--tidy-text-muted);" />
                        }
                        <tidy-toggle
                          [toggled]="remoteInspectionEnabled"
                          (toggleChanged)="toggleRemoteInspection()" />
                      </tidy-row>
                    </tidy-row>
                    @if (remoteInspectionEnabled) {
                      <tidy-row class="vertical-align-center remote-inspection-row">
                        <tidy-text [body]="'Take'" />
                        <tidy-header-select
                          [items]="remoteInspectionTypeItems"
                          [(ngModel)]="remoteInspectionType"
                          (optionChange)="onRemoteInspectionChange()"
                          style="margin-left: 5px;" />
                        <tidy-header-select
                          [items]="remoteInspectionWhenItems"
                          [(ngModel)]="remoteInspectionWhen"
                          (optionChange)="onRemoteInspectionChange()"
                          style="margin-left: 5px;" />
                        <tidy-text [body]="'Job'" style="margin-left: 5px;" />
                      </tidy-row>
                    }
                  }
                }
                @if (rooms?.length > 0) {
                  <tidy-drag-drop
                    dragDropId="favorites-dd"
                    [dataList]="rooms"
                    emptyListColor="green"
                    emptyDisabledListMessage="No Sections Added"
                    [disabled]="!editPrio"
                    [boundary]="'tidy-wrapper'"
                    (listDropped)="updatePriorities($event)"
                    >
                    @for (room of rooms; track room) {
                        <ng-container *tidyDragDropItem>
                          <tidy-card class="no-padding">
                            <tidy-card-button
                              class="arrow-to-top room-card-button"
                              [customArrowPositon]="{ top: '18px', right: '15px' }"
                              [hideArrow]="true"
                              style="padding: 12px; padding-right: 12px !important;"
                              >
                              <tidy-row [alignLastItemRight]="true" class="vertical-align-center">
                                <tidy-row class="vertical-align-center reorder-card-row" [style.paddingBottom]="editPrio ? '0px' : '5px'">
                                  @if (editPrio) {
                                    <tidy-image
                                      [src]="'assets/svg/menu-outline.svg'"
                                      class="title-size drag-handle-icon" />
                                    @if (editingRoomId === room.id) {
                                      <tidy-input
                                        [id]="'room-name-input-' + room.id"
                                        [(ngModel)]="room.name"
                                        (blur)="saveRoomNameInline(room, room.name)"
                                        (keydown.enter)="saveRoomNameInline(room, room.name)"
                                        (click)="$event.stopPropagation()"
                                        class="reorder-card-name-input" />
                                    } @else {
                                      <tidy-text
                                        [title]="room?.name"
                                        [translate]="false" />
                                    }
                                  } @else {
                                    <tidy-text
                                      [title]="room?.name"
                                      [translate]="false" />
                                  }
                                </tidy-row>
                                @if (editPrio) {
                                  <tidy-row class="vertical-align-center reorder-card-actions" style="padding-bottom: 0px;" (click)="$event.stopPropagation()">
                                    <tidy-image
                                      [src]="'assets/svg/create-outline.svg'"
                                      class="body-size reorder-action-icon"
                                      (click)="editRoomNameInline(room)" />
                                    <tidy-image
                                      [src]="'assets/svg/trash-outline.svg'"
                                      class="body-size reorder-action-icon"
                                      (click)="deleteRoom(room)" />
                                  </tidy-row>
                                }
                                @if (!editPrio) {
                                  <tidy-row class="vertical-align-center card-header-actions" (click)="$event.stopPropagation()">
                                    <tidy-drop-down-menu class="section-dropdown-menu">
                                      <tidy-drop-down-menu-item (click)="editRoomNameInline(room); enterReorderMode()">
                                        {{ 'Edit' | translate }}
                                      </tidy-drop-down-menu-item>
                                      <tidy-drop-down-menu-item (click)="deleteRoom(room)">
                                        {{ 'Delete' | translate }}
                                      </tidy-drop-down-menu-item>
                                    </tidy-drop-down-menu>
                                  </tidy-row>
                                }
                              </tidy-row>
                              @if (!editPrio) {
                                @if (room?.items?.length > 0) {
                                  <tidy-drag-drop
                                  [dragDropId]="'items-dd-' + room.id"
                                  [dataList]="room.items"
                                  [disabled]="editingToDoId !== null || editingTextItemId !== null || editingPhotoItemId !== null"
                                  (listDropped)="updateItemOrder(room, $event)">
                                  @for (item of room?.items; track item; let last = $last) {
                                    <ng-container *tidyDragDropItem>
                                      @switch (item.item_type) {
                                        @case ('checklist') {
                                          @if (!$any(item)?.task_type?.includes('video')) {
                                            @if (!isEditing($any(item).original_id)) {
                                              <div class="todo-item-collapsed" [ngClass]="{'extra-bottom-padding': !last}">
                                                <div class="checklist-item-row">
                                                  <div class="checklist-checkbox"
                                                  (click)="enterEditMode($any(item), $event, room)"
                                                  data-tooltip="Pros will check this as they work on your list">
                                                    <tidy-image [src]="'assets/svg/checkbox-outline.svg'" class="checklist-checkbox-icon" />
                                                  </div>
                                                  <div class="checklist-content" (click)="enterEditMode($any(item), $event, room)">
                                                    <div class="checklist-title-row">
                                                      @if ($any(item)?.is_important) {
                                                        <tidy-image [src]="'assets/img/star.svg'" class="body-size" />
                                                      }
                                                      <tidy-text [body]="$any(item)?.title" [translate]="false" />
                                                      @if (savedToDoId === $any(item).original_id) {
                                                        <span class="saved-indicator">Saved</span>
                                                      }
                                                    </div>
                                                    @if ($any(item)?.note) {
                                                      <div class="todo-preview-row vertical-align-center">
                                                        <tidy-image [src]="'assets/svg/text-outline.svg'" class="preview-icon" />
                                                        <tidy-text [helper]="truncateText($any(item).note, 60)" />
                                                      </div>
                                                    }
                                                    @if ($any(item)?.room_object?.name) {
                                                      <div class="todo-preview-row vertical-align-center">
                                                        <tidy-image [src]="'assets/svg/cube-outline.svg'" class="preview-icon" />
                                                        <tidy-text [helper]="('Inventory: ' | translate) + $any(item).room_object.name" />
                                                      </div>
                                                    }
                                                    @if ($any(item)?.options?.length > 0) {
                                                      <div class="todo-preview-row vertical-align-center">
                                                        <tidy-image [src]="'assets/svg/list-outline.svg'" class="preview-icon" />
                                                        <tidy-text [helper]="getCustomFieldsSummary($any(item))" />
                                                      </div>
                                                    }
                                                    @if (getPhotoCount($any(item)) > 0) {
                                                      <div class="todo-preview-row vertical-align-center">
                                                        <tidy-image [src]="'assets/svg/camera-outline.svg'" class="preview-icon" />
                                                        <tidy-text [helper]="getPhotoCount($any(item)) + (' photo' | translate) + (getPhotoCount($any(item)) > 1 ? ('s' | translate) : '')" />
                                                      </div>
                                                    }
                                                  </div>
                                                  <div class="todo-drag-handle" cdkDragHandle (click)="$event.stopPropagation()">
                                                    <tidy-image [src]="'assets/svg/menu-outline.svg'" class="drag-handle-icon-inline" />
                                                  </div>
                                                </div>
                                              </div>
                                            }
                                            @if (isEditing($any(item).original_id)) {
                                              <div class="todo-item-editing extra-left-padding extra-right-padding" [ngClass]="{'extra-bottom-padding': !last}" (click)="$event.stopPropagation()">
                                                <div class="inline-edit-panel">
                                                  <div class="inline-edit-header">
                                                    <span class="section-label">{{ 'Edit Checklist Item' | translate }}</span>
                                                    <ion-icon
                                                      name="close-outline"
                                                      class="edit-close-btn"
                                                      (click)="saveAndExitEditMode($any(item))" />
                                                  </div>
                                                  @if (currentTaskSuggestions?.length > 0 && !$any(item).title) {
                                                    <tidy-row [alignLastItemRight]="true" class="task-label-row">
                                                      <tidy-text [body]="'What needs to be done?'" />
                                                      <tidy-row class="task-suggestions">
                                                        @for (suggestion of (windowService.isDesktopRes ? currentTaskSuggestions : currentTaskSuggestions.slice(0, 2)); track suggestion; let first = $first) {
                                                          @if (!first) {
                                                            <tidy-text [helper]="'•'" class="suggestion-separator" />
                                                          }
                                                          <tidy-text
                                                            [actionBody]="suggestion"
                                                            (action)="applyTaskSuggestion(suggestion, false, $any(item), room)"
                                                            class="link suggestion-link" />
                                                        }
                                                      </tidy-row>
                                                    </tidy-row>
                                                  } @else {
                                                    <tidy-text [body]="'What needs to be done?'" class="task-label-standalone" />
                                                  }
                                                  <div class="inline-title-row">
                                                    <tidy-auto-complete
                                                      [(ngModel)]="$any(item).title"
                                                      (keydown.enter)="saveToDoInline($any(item), 'title', $any(item).title)"
                                                      [options]="toDoAutoComplete"
                                                      [showOnFocus]="true"
                                                      [isToSearchBetweenOptions]="true"
                                                      class="inline-title-input" />
                                                    <img
                                                      src="assets/svg/camera-outline.svg"
                                                      class="inline-star"
                                                      (click)="addPhotoToToDo($any(item), room)" />
                                                    @if (photoUploading[$any(item).original_id]) {
                                                      <ion-spinner name="crescent" class="inline-mini-spinner" />
                                                    }
                                                    <img
                                                      src="assets/img/star.svg"
                                                      class="inline-star"
                                                      [class.star-active]="$any(item)?.is_important"
                                                      (click)="toggleImportant($any(item), $event)" />
                                                    @if (savingToDoId === $any(item).original_id) {
                                                      <ion-spinner name="crescent" class="inline-saving-spinner" />
                                                    }
                                                  </div>
                                                  <tidy-textarea
                                                    [(ngModel)]="$any(item).note"
                                                    [label]="'Notes (optional)'" />
                                                  <div class="inline-action-row">
                                                    <button class="section-add-pill" (click)="addInlineCustomField($any(item))">
                                                      <tidy-image [src]="'assets/svg/information-outline.svg'" class="header-size" />
                                                      <span>{{ '+ Collect Information' | translate }}</span>
                                                    </button>
                                                    @if (!$any(item)?.room_object && !showInlineInventory[$any(item).original_id]) {
                                                      <button class="section-add-pill" (click)="addInlineInventory($any(item))">
                                                        <tidy-image [src]="'assets/svg/clipboard-outline.svg'" class="header-size" />
                                                        <span>{{ '+ Inventory' | translate }}</span>
                                                      </button>
                                                    }
                                                  </div>
                                                  @if ($any(item)?.photo_notes?.length > 0 || pendingToDoPhotos[$any(item).original_id]?.length > 0) {
                                                    <div class="inline-content-section">
                                                      <div class="inline-section-header">
                                                        <span class="section-label">{{ 'Photos' | translate }}</span>
                                                      </div>
                                                      @if ($any(item)?.photo_notes?.length > 0) {
                                                        <div class="inline-photos-grid">
                                                          @for (photo of $any(item).photo_notes; track photo) {
                                                            <img [src]="photo.photo_url" class="inline-photo-thumbnail" />
                                                          }
                                                        </div>
                                                      }
                                                      @if (pendingToDoPhotos[$any(item).original_id]?.length > 0) {
                                                        <div class="inline-section-header" style="margin-top: 10px;">
                                                          <span class="section-label">{{ 'New Photos (unsaved)' | translate }}</span>
                                                        </div>
                                                        @for (photo of pendingToDoPhotos[$any(item).original_id]; track photo; let i = $index) {
                                                          <div class="inline-photo-preview-item">
                                                            <div class="photo-preview-row">
                                                              <img [src]="photo.url" class="photo-preview-image" />
                                                              <div class="photo-preview-caption-wrapper">
                                                                <tidy-input
                                                                  [(ngModel)]="photo.photoNoteCaption"
                                                                  [label]="'Add caption (optional)'"
                                                                  (input)="markPendingToDoPhotoChanged(photo)" />
                                                                <tidy-text
                                                                  [actionBody]="'Remove'"
                                                                  (action)="removePendingToDoPhoto($any(item), i)"
                                                                  class="link red" />
                                                              </div>
                                                            </div>
                                                          </div>
                                                        }
                                                        <div class="inline-action-row">
                                                          <button class="section-add-pill" (click)="addPhotoToToDo($any(item), room)">
                                                            <tidy-image [src]="'assets/svg/camera-outline.svg'" class="header-size" />
                                                            <span>{{ '+ Add More Photos' | translate }}</span>
                                                          </button>
                                                        </div>
                                                        <div class="inline-footer-row" style="margin-top: 10px;">
                                                          <tidy-small-button
                                                            [text]="photoUploading[$any(item).original_id] ? 'Saving...' : 'Save Photos'"
                                                            [image]="'assets/svg/checkmark-outline.svg'"
                                                            [primary]="true"
                                                            [disabled]="photoUploading[$any(item).original_id]"
                                                            (buttonClick)="savePendingToDoPhotos($any(item), room)" />
                                                        </div>
                                                      }
                                                    </div>
                                                  }
                                                  @if ($any(item)?.room_object || showInlineInventory[$any(item).original_id]) {
                                                    <div class="inline-content-section">
                                                      <div class="inline-section-header">
                                                        <span class="section-label">{{ 'Take Inventory' | translate }}</span>
                                                        <tidy-image
                                                          [src]="'assets/svg/trash-outline.svg'"
                                                          class="body-size section-remove-icon"
                                                          (click)="removeInventory($any(item))" />
                                                      </div>
                                                      <div class="inline-inventory-row">
                                                        <div class="inline-inventory-input-wrapper">
                                                          <tidy-input
                                                            [label]="'Item name'"
                                                            [(ngModel)]="inlineInventoryName[$any(item).original_id]"
                                                            (ngModelChange)="searchInventoryItems($any(item), inlineInventoryName[$any(item).original_id])"
                                                            (blur)="hideInventorySuggestions($any(item))"
                                                            (keydown.enter)="hideInventorySuggestions($any(item)); saveInventoryInline($any(item))" />
                                                          @if (inventorySearching[$any(item).original_id]) {
                                                            <ion-spinner name="crescent" class="inventory-search-spinner" />
                                                          }
                                                          @if (inventorySuggestions[$any(item).original_id]?.length > 0) {
                                                            <div class="inventory-suggestions">
                                                              @for (suggestion of inventorySuggestions[$any(item).original_id]; track suggestion.id) {
                                                                <div
                                                                  class="inventory-suggestion-item"
                                                                  (mousedown)="selectInventorySuggestion($any(item), suggestion)">
                                                                  <span class="suggestion-name">{{suggestion.name}}</span>
                                                                  @if (suggestion.genome_category_name) {
                                                                    <span class="suggestion-category">{{suggestion.genome_category_name}}</span>
                                                                  }
                                                                </div>
                                                              }
                                                            </div>
                                                          }
                                                        </div>
                                                        <tidy-select
                                                          [(ngModel)]="inlineInventoryCategory[$any(item).original_id]"
                                                          [items]="categoryItems"
                                                          [label]="'Category...'"
                                                          (ngModelChange)="saveInventoryInline($any(item))"
                                                          class="inline-inventory-category" />
                                                      </div>
                                                      <span class="inline-inventory-helper">{{ 'When a pro completes this, the matching restocking item will be updated (or added if not present).' | translate }}</span>
                                                    </div>
                                                  }
                                                  @if ($any(item)?.options?.length > 0 || inlineCustomFields[$any(item).original_id]?.length > 0) {
                                                    <div class="inline-content-section">
                                                      <div class="inline-section-header">
                                                        <span class="section-label">{{ 'Collect Information' | translate }}</span>
                                                      </div>
                                                      @for (option of $any(item).options; track option; let optIdx = $index) {
                                                        @if (!isOptionInInlineFields($any(item), option.id)) {
                                                          <div class="inline-custom-field-wrapper">
                                                            <div class="inline-field-header">
                                                              <tidy-checkbox
                                                                [(checked)]="option.required"
                                                                [items]="[{viewValue: 'Required', value: true}]"
                                                                [initValue]="option.required" />
                                                              <tidy-image
                                                                [src]="'assets/svg/trash-outline.svg'"
                                                                class="body-size section-remove-icon"
                                                                (click)="removeExistingOption($any(item), optIdx)" />
                                                            </div>
                                                            <div class="inline-field-row">
                                                              <tidy-select
                                                                [(ngModel)]="option._typeId"
                                                                [items]="customFieldTypes"
                                                                [label]="'Field type...'"
                                                                (ngModelChange)="onExistingFieldTypeChange($any(item), optIdx)"
                                                                class="field-type-select" />
                                                              <tidy-input
                                                                [label]="'What should pro do?'"
                                                                [(ngModel)]="option.notes" />
                                                            </div>
                                                            @if (getExistingFieldRequiredOptions(option) > 0) {
                                                              <div class="inline-options-section">
                                                                <div class="inline-options-header">
                                                                  <span class="options-label">{{ 'Options' | translate }}</span>
                                                                  <tidy-text
                                                                    [actionBody]="'+ Add Option'"
                                                                    (action)="addExistingOptionValue($any(item), optIdx)"
                                                                    class="link" />
                                                                </div>
                                                                @for (val of option.allowed_values; track $index; let valIdx = $index) {
                                                                  <div class="inline-option-row">
                                                                    <tidy-input
                                                                      [label]="('Option ' | translate) + ((valIdx | translate) + (1 | translate))"
                                                                      [(ngModel)]="option.allowed_values[valIdx]" />
                                                                    <tidy-image
                                                                      [src]="'assets/svg/trash-outline.svg'"
                                                                      class="body-size section-remove-icon"
                                                                      style="position: relative; top: 10px;"
                                                                      (click)="removeExistingOptionValue($any(item), optIdx, valIdx)" />
                                                                  </div>
                                                                }
                                                                @if (option.allowed_values?.length < getExistingFieldRequiredOptions(option)) {
                                                                  <span class="options-helper">Add at least {{getExistingFieldRequiredOptions(option)}} option{{getExistingFieldRequiredOptions(option) > 1 ? 's' : ''}}</span>
                                                                }
                                                              </div>
                                                            }
                                                          </div>
                                                        }
                                                      }
                                                      @for (field of inlineCustomFields[$any(item).original_id]; track field; let i = $index) {
                                                        <div class="inline-custom-field-wrapper">
                                                          <div class="inline-field-header">
                                                            <tidy-checkbox
                                                              [(checked)]="field.required"
                                                              (checkedChange)="toggleInlineFieldRequired($any(item), i)"
                                                              [items]="[
                                                                {
                                                                  viewValue: 'Required', value: true
                                                                }
                                                              ]"
                                                              [initValue]="field.required" />
                                                            <tidy-image
                                                              [src]="'assets/svg/trash-outline.svg'"
                                                              class="body-size section-remove-icon"
                                                              (click)="removeInlineCustomField($any(item), i)" />
                                                          </div>
                                                          <div class="inline-field-row">
                                                            <tidy-select
                                                              [(ngModel)]="field.type"
                                                              [items]="customFieldTypes"
                                                              [label]="'Field type...'"
                                                              (ngModelChange)="onInlineFieldTypeChange($any(item), i)"
                                                              class="field-type-select" />
                                                            <tidy-input
                                                              [label]="'What should pro do?'"
                                                              [(ngModel)]="field.label" />
                                                          </div>
                                                          @if (field.numberOfRequiredOptions > 0) {
                                                            <div class="inline-options-section">
                                                              <div class="inline-options-header">
                                                                <span class="options-label">{{ 'Options' | translate }}</span>
                                                                <tidy-text
                                                                  [actionBody]="'+ Add Option'"
                                                                  (action)="addInlineFieldOption($any(item), i)"
                                                                  class="link" />
                                                              </div>
                                                              @for (opt of field.options; track $index; let optIdx = $index) {
                                                                <div class="inline-option-row">
                                                                  <tidy-input
                                                                    [label]="('Option ' | translate) + ((optIdx | translate) + (1 | translate))"
                                                                    [(ngModel)]="field.options[optIdx]" />
                                                                  <tidy-image
                                                                    [src]="'assets/svg/trash-outline.svg'"
                                                                    class="body-size section-remove-icon"
                                                                    (click)="removeInlineFieldOption($any(item), i, optIdx)" />
                                                                </div>
                                                              }
                                                              @if (field.options.length < field.numberOfRequiredOptions) {
                                                                <span class="options-helper">Add at least {{field.numberOfRequiredOptions}} option{{field.numberOfRequiredOptions > 1 ? 's' : ''}}</span>
                                                              }
                                                            </div>
                                                          }
                                                        </div>
                                                      }
                                                    </div>
                                                  }
                                                  <div class="inline-footer-row new-todo-actions">
                                                    <tidy-small-button
                                                      [text]="'Delete'"
                                                      [image]="'assets/svg/trash-outline.svg'"
                                                      [danger]="true"
                                                      (buttonClick)="deleteToDo($any(item))" />
                                                    <tidy-small-button
                                                      [text]="'Save'"
                                                      [image]="'assets/svg/checkmark-outline.svg'"
                                                      [primary]="true"
                                                      (buttonClick)="saveAndExitEditMode($any(item))" />
                                                  </div>
                                                </div>
                                              </div>
                                            }
                                          }
                                        }
                                        @case ('text') {
                                          @if (!isEditingTextItem(item.id)) {
                                            <div class="text-item-collapsed extra-right-padding" [ngClass]="{'extra-bottom-padding': !last}">
                                              <div class="text-item-note-icon" (click)="enterTextEditMode($any(item), $event)">
                                                <tidy-image [src]="'assets/svg/text-outline.svg'" class="text-item-icon" />
                                              </div>
                                              <div class="text-item-content" (click)="enterTextEditMode($any(item), $event)">
                                                <tidy-markdown [markdownContent]="$any(item).content" />
                                              </div>
                                              <div class="todo-drag-handle" cdkDragHandle (click)="$event.stopPropagation()">
                                                <tidy-image [src]="'assets/svg/menu-outline.svg'" class="drag-handle-icon-inline" />
                                              </div>
                                            </div>
                                          } @else {
                                            <div class="text-item-editing extra-left-padding extra-right-padding" [ngClass]="{'extra-bottom-padding': !last}" (click)="$event.stopPropagation()">
                                              <div class="inline-edit-panel">
                                                <div class="inline-edit-header">
                                                  <span class="section-label">{{ 'Edit Note' | translate }}</span>
                                                  <ion-icon
                                                    name="close-outline"
                                                    class="edit-close-btn"
                                                    (click)="exitTextEditMode()" />
                                                </div>
                                                <tidy-textarea
                                                  [(ngModel)]="$any(item).content"
                                                  [label]="'Enter text (supports **bold**, _italic_, [links](url))'" />
                                                <div class="inline-footer-row new-todo-actions">
                                                  <tidy-small-button
                                                    [text]="'Delete'"
                                                    [image]="'assets/svg/trash-outline.svg'"
                                                    [danger]="true"
                                                    (buttonClick)="deleteTextItem($any(item), room)" />
                                                  <tidy-small-button
                                                    [text]="'Save'"
                                                    [image]="'assets/svg/checkmark-outline.svg'"
                                                    [primary]="true"
                                                    (buttonClick)="saveTextItem($any(item), $any(item).content); exitTextEditMode()" />
                                                </div>
                                              </div>
                                            </div>
                                          }
                                        }
                                        @case ('photo') {
                                          @if (!isEditingPhotoItem(item.id)) {
                                            <div class="photo-item" [ngClass]="{'extra-bottom-padding': !last}">
                                              <div class="photo-item-wrapper">
                                                <div class="photo-item-left" (click)="enterPhotoEditMode($any(item), $event)">
                                                  <img [src]="$any(item).photo_url" class="photo-item-image" />
                                                  @if ($any(item).photo_note_caption) {
                                                    <div class="photo-caption-indicator">
                                                      <tidy-image [src]="'assets/svg/chatbubble-outline.svg'" class="preview-icon" />
                                                      <tidy-text [helper]="$any(item).photo_note_caption" />
                                                    </div>
                                                  }
                                                </div>
                                                <div class="todo-drag-handle" cdkDragHandle (click)="$event.stopPropagation()">
                                                  <tidy-image [src]="'assets/svg/menu-outline.svg'" class="drag-handle-icon-inline" />
                                                </div>
                                              </div>
                                            </div>
                                          } @else {
                                            <div class="photo-item-editing extra-left-padding extra-right-padding" [ngClass]="{'extra-bottom-padding': !last}" (click)="$event.stopPropagation()">
                                              <div class="inline-edit-panel">
                                                <div class="inline-edit-header">
                                                  <span class="section-label">{{ 'Edit Photo' | translate }}</span>
                                                  <ion-icon
                                                    name="close-outline"
                                                    class="edit-close-btn"
                                                    (click)="exitPhotoEditMode()" />
                                                </div>
                                                <div class="photo-item-edit-container">
                                                  <img [src]="$any(item).photo_url" class="photo-item-image-edit" />
                                                  <tidy-input
                                                    [(ngModel)]="$any(item).photo_note_caption"
                                                    [label]="'Caption'" />
                                                </div>
                                                <div class="inline-footer-row new-todo-actions">
                                                  <tidy-small-button
                                                    [text]="'Delete'"
                                                    [image]="'assets/svg/trash-outline.svg'"
                                                    [danger]="true"
                                                    (buttonClick)="deletePhotoItem($any(item), room)" />
                                                  <tidy-small-button
                                                    [text]="'Save'"
                                                    [image]="'assets/svg/checkmark-outline.svg'"
                                                    [primary]="true"
                                                    (buttonClick)="savePhotoCaption($any(item), $any(item).photo_note_caption); exitPhotoEditMode()" />
                                                </div>
                                              </div>
                                            </div>
                                          }
                                        }
                                      }
                                    </ng-container>
                                  }
                                </tidy-drag-drop>
                              }
                                @if (addingToDoRoomId !== room.id && addingTextItemRoomId !== room.id) {
                                    <div class="section-add-buttons extra-bottom-padding" (click)="$event.stopPropagation()">
                                      <button class="section-add-pill" (click)="startAddToDoInline(room)">
                                        <tidy-image [src]="'assets/svg/checkbox-outline.svg'" class="header-size" />
                                        <span>{{ (windowService.isDesktopRes ? 'Add Checklist Item' : 'Checklist Item') | translate }}</span>
                                      </button>
                                      <button class="section-add-pill" (click)="startAddTextItem(room)">
                                        <tidy-image [src]="'assets/svg/text-outline.svg'" class="header-size" />
                                        <span>{{ (windowService.isDesktopRes ? 'Add Text' : 'Text') | translate }}</span>
                                      </button>
                                      <button class="section-add-pill" (click)="startAddPhotoItem(room)">
                                        <tidy-image [src]="'assets/svg/camera-outline.svg'" class="header-size" />
                                        <span>{{ (windowService.isDesktopRes ? 'Add Photo' : 'Photo') | translate }}</span>
                                      </button>
                                    </div>
                                  }
                                  @if (addingToDoRoomId === room.id && newToDo) {
                                    <div class="todo-item-editing extra-left-padding extra-right-padding extra-bottom-padding" (click)="$event.stopPropagation()">
                                      <div class="inline-edit-panel">
                                        @if (currentTaskSuggestions?.length > 0 && !newToDo.title) {
                                          <tidy-row [alignLastItemRight]="true" class="task-label-row">
                                            <tidy-text [body]="'What needs to be done?'" />
                                            <tidy-row class="task-suggestions">
                                              @for (suggestion of (windowService.isDesktopRes ? currentTaskSuggestions : currentTaskSuggestions.slice(0, 2)); track suggestion; let first = $first) {
                                                @if (!first) {
                                                  <tidy-text [helper]="'•'" class="suggestion-separator" />
                                                }
                                                <tidy-text
                                                  [actionBody]="suggestion"
                                                  (action)="applyTaskSuggestion(suggestion, true, null, room)"
                                                  class="link suggestion-link" />
                                              }
                                            </tidy-row>
                                          </tidy-row>
                                        } @else {
                                          <tidy-text [body]="'What needs to be done?'" class="task-label-standalone" />
                                        }
                                        <div class="inline-title-row">
                                          <tidy-auto-complete
                                            id="new-todo-title-input"
                                            [(ngModel)]="newToDo.title"
                                            (keydown.enter)="saveNewToDo(room)"
                                            [options]="toDoAutoComplete"
                                            [showOnFocus]="true"
                                            [isToSearchBetweenOptions]="true"
                                            class="inline-title-input" />
                                          <img
                                            src="assets/svg/camera-outline.svg"
                                            class="inline-star"
                                            (click)="addPhotoToNewToDo()" />
                                          @if (newToDoPhotoUploading) {
                                            <ion-spinner name="crescent" class="inline-mini-spinner" />
                                          }
                                          <img
                                            src="assets/img/star.svg"
                                            class="inline-star"
                                            [class.star-active]="newToDo.is_important"
                                            (click)="toggleNewToDoImportant()" />
                                        </div>
                                        <tidy-textarea
                                          [(ngModel)]="newToDo.note"
                                          [label]="'Notes (optional)'"
                                          (ngModelChange)="updateNewToDoField('note', newToDo.note)" />
                                        @if (newToDoPhotos?.length > 0) {
                                          <div class="inline-content-section">
                                            <div class="inline-section-header">
                                              <span class="section-label">{{ 'Photos' | translate }}</span>
                                            </div>
                                            @for (photo of newToDoPhotos; track photo; let i = $index) {
                                              <div class="inline-photo-preview-item">
                                                <div class="photo-preview-row">
                                                  <img [src]="photo.url" class="photo-preview-image" />
                                                  <div class="photo-preview-caption-wrapper">
                                                    <tidy-input
                                                      [(ngModel)]="photo.photoNoteCaption"
                                                      [label]="'Add caption (optional)'"
                                                      (input)="markNewToDoPhotoChanged(photo)" />
                                                    <tidy-text
                                                      [actionBody]="'Remove'"
                                                      (action)="removeNewToDoPhoto(i)"
                                                      class="link red" />
                                                  </div>
                                                </div>
                                              </div>
                                            }
                                            <div class="inline-action-row">
                                              <button class="section-add-pill" (click)="addPhotoToNewToDo()">
                                                <tidy-image [src]="'assets/svg/camera-outline.svg'" class="header-size" />
                                                <span>{{ '+ Add More Photos' | translate }}</span>
                                              </button>
                                            </div>
                                          </div>
                                        }
                                        <div class="inline-action-row">
                                          <button class="section-add-pill" (click)="addNewToDoCustomField()">
                                            <tidy-image [src]="'assets/svg/information-outline.svg'" class="header-size" />
                                            <span>{{ '+ Collect Information' | translate }}</span>
                                          </button>
                                          @if (!showNewToDoInventory) {
                                            <button class="section-add-pill" (click)="addNewToDoInventory()">
                                              <tidy-image [src]="'assets/svg/clipboard-outline.svg'" class="header-size" />
                                              <span>{{ '+ Inventory' | translate }}</span>
                                            </button>
                                          }
                                        </div>
                                        @if (showNewToDoInventory) {
                                          <div class="inline-content-section">
                                            <div class="inline-section-header">
                                              <span class="section-label">{{ 'Take Inventory' | translate }}</span>
                                              <tidy-image
                                                [src]="'assets/svg/trash-outline.svg'"
                                                class="body-size section-remove-icon"
                                                (click)="removeNewToDoInventory()" />
                                            </div>
                                            <div class="inline-inventory-row">
                                              <div class="inline-inventory-input-wrapper">
                                                <tidy-input
                                                  [label]="'Item name'"
                                                  [(ngModel)]="newToDoInventoryName"
                                                  (ngModelChange)="searchNewToDoInventoryItems(newToDoInventoryName)"
                                                  (blur)="hideNewToDoInventorySuggestions()" />
                                                @if (newToDoInventorySearching) {
                                                  <ion-spinner name="crescent" class="inventory-search-spinner" />
                                                }
                                                @if (newToDoInventorySuggestions?.length > 0) {
                                                  <div class="inventory-suggestions">
                                                    @for (suggestion of newToDoInventorySuggestions; track suggestion.id) {
                                                      <div
                                                        class="inventory-suggestion-item"
                                                        (mousedown)="selectNewToDoInventorySuggestion(suggestion)">
                                                        <span class="suggestion-name">{{suggestion.name}}</span>
                                                        @if (suggestion.genome_category_name) {
                                                          <span class="suggestion-category">{{suggestion.genome_category_name}}</span>
                                                        }
                                                      </div>
                                                    }
                                                  </div>
                                                }
                                              </div>
                                              <tidy-select
                                                [(ngModel)]="newToDoInventoryCategory"
                                                [items]="categoryItems"
                                                [label]="'Category...'"
                                                class="inline-inventory-category" />
                                            </div>
                                            <span class="inline-inventory-helper">{{ 'When a pro completes this, the matching restocking item will be updated (or added if not present).' | translate }}</span>
                                          </div>
                                        }
                                        @if (newToDoCustomFields?.length > 0) {
                                          <div class="inline-content-section">
                                            <div class="inline-section-header">
                                              <span class="section-label">{{ 'Collect Information' | translate }}</span>
                                            </div>
                                            @for (field of newToDoCustomFields; track field; let i = $index) {
                                              <div class="inline-custom-field-wrapper">
                                                <div class="inline-field-header">
                                                  <tidy-checkbox
                                                    [(checked)]="field.required"
                                                    [items]="[{viewValue: 'Required', value: true}]"
                                                    [initValue]="field.required" />
                                                  <tidy-image
                                                    [src]="'assets/svg/trash-outline.svg'"
                                                    class="body-size section-remove-icon"
                                                    (click)="removeNewToDoCustomField(i)" />
                                                </div>
                                                <div class="inline-field-row">
                                                  <tidy-select
                                                    [(ngModel)]="field.type"
                                                    [items]="customFieldTypes"
                                                    [label]="'Field type...'"
                                                    (ngModelChange)="onNewToDoFieldTypeChange(i)"
                                                    class="field-type-select" />
                                                  <tidy-input
                                                    [label]="'What should pro do?'"
                                                    [(ngModel)]="field.label" />
                                                </div>
                                                @if (field.numberOfRequiredOptions > 0) {
                                                  <div class="inline-options-section">
                                                    <div class="inline-options-header">
                                                      <span class="options-label">{{ 'Options' | translate }}</span>
                                                      <tidy-text
                                                        [actionBody]="'+ Add Option'"
                                                        (action)="addNewToDoFieldOption(i)"
                                                        class="link" />
                                                    </div>
                                                    @for (opt of field.options; track $index; let optIdx = $index) {
                                                      <div class="inline-option-row">
                                                        <tidy-input
                                                          [label]="('Option ' | translate) + ((optIdx | translate) + (1 | translate))"
                                                          [(ngModel)]="field.options[optIdx]" />
                                                        <tidy-image
                                                          [src]="'assets/svg/trash-outline.svg'"
                                                          class="body-size section-remove-icon"
                                                          (click)="removeNewToDoFieldOption(i, optIdx)" />
                                                      </div>
                                                    }
                                                    @if (field.options.length < field.numberOfRequiredOptions) {
                                                      <span class="options-helper">Add at least {{field.numberOfRequiredOptions}} option{{field.numberOfRequiredOptions > 1 ? 's' : ''}}</span>
                                                    }
                                                  </div>
                                                }
                                              </div>
                                            }
                                          </div>
                                        }
                                        <div class="inline-footer-row new-todo-actions">
                                          <tidy-small-button
                                            [text]="'Cancel'"
                                            [image]="'assets/svg/close-outline.svg'"
                                            (buttonClick)="cancelAddToDo()" />
                                          <tidy-small-button
                                            [text]="'Save'"
                                            [image]="'assets/svg/checkmark-outline.svg'"
                                            [primary]="true"
                                            (buttonClick)="saveNewToDo(room)" />
                                        </div>
                                      </div>
                                    </div>
                                  }
                                  @if (addingPhotoRoomId === room.id && pendingSectionPhotos?.length > 0) {
                                    <div class="photo-preview-editing extra-left-padding extra-right-padding extra-bottom-padding" (click)="$event.stopPropagation()">
                                      <div class="inline-edit-panel">
                                        <div class="inline-section-header">
                                          <span class="section-label">{{ 'Add Photos' | translate }}</span>
                                        </div>
                                        @for (photo of pendingSectionPhotos; track photo; let i = $index) {
                                          <div class="inline-photo-preview-item">
                                            <div class="photo-preview-row">
                                              <img [src]="photo.url" class="photo-preview-image" />
                                              <div class="photo-preview-caption-wrapper">
                                                <tidy-input
                                                  [(ngModel)]="photo.photoNoteCaption"
                                                  [label]="'Add caption (optional)'"
                                                  (input)="markPendingPhotoChanged(photo)" />
                                                <tidy-text
                                                  [actionBody]="'Remove'"
                                                  (action)="removePendingSectionPhoto(i)"
                                                  class="link red" />
                                              </div>
                                            </div>
                                          </div>
                                        }
                                        <div class="inline-action-row">
                                          <button class="section-add-pill" (click)="addMoreSectionPhotos(room)">
                                            <tidy-image [src]="'assets/svg/camera-outline.svg'" class="header-size" />
                                            <span>{{ '+ Add More Photos' | translate }}</span>
                                          </button>
                                        </div>
                                        <div class="inline-footer-row new-todo-actions">
                                          <tidy-small-button
                                            [text]="'Cancel'"
                                            [image]="'assets/svg/close-outline.svg'"
                                            (buttonClick)="cancelAddSectionPhoto()" />
                                          <tidy-small-button
                                            [text]="sectionPhotoUploading ? 'Saving...' : 'Save'"
                                            [image]="'assets/svg/checkmark-outline.svg'"
                                            [primary]="true"
                                            [disabled]="sectionPhotoUploading"
                                            (buttonClick)="saveSectionPhotos(room)" />
                                        </div>
                                      </div>
                                    </div>
                                  }
                                  @if (addingTextItemRoomId === room.id && newTextItem) {
                                    <div class="text-item-editing extra-left-padding extra-right-padding extra-bottom-padding" (click)="$event.stopPropagation()">
                                      <div class="inline-edit-panel">
                                        <tidy-textarea
                                          id="new-text-item-input"
                                          [(ngModel)]="newTextItem.content"
                                          [label]="'Enter text (supports **bold**, _italic_, [links](url))'"
                                          (ngModelChange)="updateNewTextItemField(newTextItem.content)" />
                                        <div class="inline-footer-row new-todo-actions">
                                          <tidy-small-button
                                            [text]="'Cancel'"
                                            [image]="'assets/svg/close-outline.svg'"
                                            (buttonClick)="cancelAddTextItem()" />
                                          <tidy-small-button
                                            [text]="'Save'"
                                            [image]="'assets/svg/checkmark-outline.svg'"
                                            [primary]="true"
                                            (buttonClick)="saveNewTextItem(room)" />
                                        </div>
                                      </div>
                                    </div>
                                  }
                                }
                              </tidy-card-button>
                              <div></div>
                            </tidy-card>
                          </ng-container>
                      }
                    </tidy-drag-drop>
                }
                @if (editPrio) {
                  <tidy-card class="no-padding add-card-inline-card">
                    <tidy-row [alignLastItemRight]="true" class="vertical-align-center" style="padding: 12px;">
                      <tidy-row class="vertical-align-center reorder-card-row">
                        <tidy-image
                          [src]="'assets/svg/menu-outline.svg'"
                          class="title-size drag-handle-icon add-card-drag-placeholder" />
                        <tidy-input
                          #addCardInput
                          [label]="'Type to add section'"
                          [(ngModel)]="newCardName"
                          (keydown.enter)="addCardInline()"
                          (blur)="addCardInline()"
                          class="input-align-left" />
                      </tidy-row>
                    </tidy-row>
                  </tidy-card>
                } @else {
                  <tidy-row>
                    <tidy-button
                      [text]="'Add Section'"
                      [action]="enterReorderModeWithAdd.bind(this)"
                      class="secondary" />
                  </tidy-row>
                  @if (visibleSuggestions?.length > 0) {
                    <tidy-row [align]="'right'" class="section-suggestions">
                      @for (suggestion of visibleSuggestions; track suggestion; let first = $first) {
                        @if (!first) {
                          <tidy-text [helper]="'•'" class="suggestion-separator" />
                        }
                        <tidy-text
                          [actionBody]="suggestion"
                          (action)="addSuggestedSection(suggestion)"
                          class="link suggestion-link" />
                      }
                    </tidy-row>
                  }
                }
                @if (editPrio && !isRightSideContent) {
                  <tidy-row [align]="'right'" class="extra-top-padding">
                    <tidy-button
                      [text]="'Done'"
                      [action]="exitReorderMode.bind(this)"
                      class="primary" />
                  </tidy-row>
                }

                }
              }
            }
          }
        }
      }

      @if (loaded && toDosOnboarding && !showAboutThisPage && hasAddresses) {
        <to-dos-onboarding
          [addressResponse]="addressResponse"
          [addressId]="addressId"
          [isNormalBookingFlow]="false" />
      }

      @if (!loaded) {
        <tidy-row [alignLastItemRight]="true" class="extra-top-padding vertical-align-center">
          <tidy-row class="vertical-align-center">
            <ion-skeleton-text animated style="width: 24px; height: 24px; border-radius: 4px;" />
            <ion-skeleton-text animated style="width: 140px; height: 16px; margin-left: 8px;" />
          </tidy-row>
          <ion-skeleton-text animated style="width: 50px; height: 24px; border-radius: 12px;" />
        </tidy-row>
        <tidy-card class="no-padding">
          <tidy-row class="extra-bottom-padding extra-top-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 45%; height: 20px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 70%; height: 14px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 55%; height: 14px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 60%; height: 14px;" />
          </tidy-row>
        </tidy-card>
        <tidy-card class="no-padding">
          <tidy-row class="extra-bottom-padding extra-top-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 35%; height: 20px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 65%; height: 14px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 50%; height: 14px;" />
          </tidy-row>
        </tidy-card>
        <tidy-card class="no-padding">
          <tidy-row class="extra-bottom-padding extra-top-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 50%; height: 20px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 75%; height: 14px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 45%; height: 14px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 55%; height: 14px;" />
          </tidy-row>
        </tidy-card>
      }

      @if (loaded && !addressLoaded && hasAddresses) {
        <tidy-row [alignLastItemRight]="true" class="extra-top-padding vertical-align-center">
          <tidy-row class="vertical-align-center">
            <ion-skeleton-text animated style="width: 24px; height: 24px; border-radius: 4px;" />
            <ion-skeleton-text animated style="width: 140px; height: 16px; margin-left: 8px;" />
          </tidy-row>
          <ion-skeleton-text animated style="width: 50px; height: 24px; border-radius: 12px;" />
        </tidy-row>
        <tidy-card class="no-padding">
          <tidy-row class="extra-bottom-padding extra-top-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 45%; height: 20px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 70%; height: 14px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 55%; height: 14px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 60%; height: 14px;" />
          </tidy-row>
        </tidy-card>
        <tidy-card class="no-padding">
          <tidy-row class="extra-bottom-padding extra-top-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 35%; height: 20px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 65%; height: 14px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 50%; height: 14px;" />
          </tidy-row>
        </tidy-card>
        <tidy-card class="no-padding">
          <tidy-row class="extra-bottom-padding extra-top-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 50%; height: 20px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 75%; height: 14px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 45%; height: 14px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 55%; height: 14px;" />
          </tidy-row>
        </tidy-card>
      }

      @if (loaded && (!listLoaded && !toDosOnboarding) && hasAddresses) {
        <tidy-row [alignLastItemRight]="true" class="extra-top-padding vertical-align-center">
          <tidy-row class="vertical-align-center">
            <ion-skeleton-text animated style="width: 24px; height: 24px; border-radius: 4px;" />
            <ion-skeleton-text animated style="width: 140px; height: 16px; margin-left: 8px;" />
          </tidy-row>
          <ion-skeleton-text animated style="width: 50px; height: 24px; border-radius: 12px;" />
        </tidy-row>
        <tidy-card class="no-padding">
          <tidy-row class="extra-bottom-padding extra-top-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 45%; height: 20px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 70%; height: 14px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 55%; height: 14px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 60%; height: 14px;" />
          </tidy-row>
        </tidy-card>
        <tidy-card class="no-padding">
          <tidy-row class="extra-bottom-padding extra-top-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 35%; height: 20px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 65%; height: 14px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 50%; height: 14px;" />
          </tidy-row>
        </tidy-card>
        <tidy-card class="no-padding">
          <tidy-row class="extra-bottom-padding extra-top-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 50%; height: 20px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 75%; height: 14px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 45%; height: 14px;" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
            <ion-skeleton-text animated style="width: 55%; height: 14px;" />
          </tidy-row>
        </tidy-card>
      }

    </tidy-wrapper>

  </ng-template>

  @if (!isRightSideContent) {
    <app-scroll-wrapper [templateContent]="content" />
  }

  @if (isRightSideContent) {
    <ion-content class="ion-content-right-column">
      <ng-container *ngTemplateOutlet="content" />
    </ion-content>
  }

  @if (showAboutThisPage) {
    <tidy-about-this-page
      [page]="'checklists'"
      (dismissed)="dismissAboutThisPage()" />
  }

